export const withDeadline = async (promise, timeoutMs, message) => {
    let timer;
    try {
        return await Promise.race([promise, new Promise((_, reject) => {
            timer = setTimeout(() => reject(new Error(message)), timeoutMs);
        })]);
    } finally { clearTimeout(timer); }
};
